<template>
<div>

<TopBar></TopBar>

<div class="">
    <div class="px-3 pb-1">
        <div class="border border-dark">
        <div id="app" class="p-1 rounded" style="height: 78vh" >     
        <l-map :zoom="zoom" :center="center"> 
            <l-tile-layer :url="url"></l-tile-layer>
            <l-control-scale position="topright" :imperial="true" :metric="true"></l-control-scale>
           <l-control position="bottomright">
              <div  style="background-color: rgba(167,149,149,0.75)">
                <div class="py-3">
                
                <div class="d-flex flex-row px-1">
                  <b-icon  icon="caret-left-fill" aria-hidden="true" scale="1" style="color:rgb(0,0,255)"></b-icon>
                  <div v-for="(color,index) in colorsArray" :key="index"   class="box"  :style="{ backgroundColor: color}"> </div>
                  <b-icon  icon="caret-right-fill" aria-hidden="true" scale="1" style="color:rgb(137,0,0)"></b-icon>
                </div>
                <div class="d-flex flex-row justify-content-between text-center px-4">  
                  <div class="vl"></div>
                  <!--<div class="vl"></div>
                  <div class="vl"></div>
                  <div class="vl"></div>
                  <div class="vl"></div>
                  <div class="vl"></div>-->
                  <div class="vl"></div>
                </div>
                <div class="d-flex flex-row justify-content-between text-center px-4">  
                  <p class="text">min</p>
                  <!--<p class="text px-2">{{Math.floor(start+(end-start)/6)}} </p>
                  <p class="text">{{Math.floor(start+2*(end-start)/6)}} </p>
                  <p class="text">{{Math.floor(start+3*(end-start)/6)}} </p>
                  <p class="text ">{{Math.floor(start+4*(end-start)/6)}}</p>
                  <p class="text">{{Math.floor(start+5*(end-start)/6)}} </p>-->
                  <p class="text">max</p>
                </div>
                <!--<div class="text text-center"><p>(mg/m<sup>2</sup>)</p></div>
                -->
                </div>
              </div>
            </l-control>


           <l-control position="bottomleft">
              <!-- <div  style="background-color: rgba(255,255,255,0.75)"> -->
            <div  style="background: none">
                <div class="py-3">
                    <a href="http://beyond-eocenter.eu/" target="_blank"><img src="/public/img/beyond_logo_cyrcle-white.png"></a>
                </div>
              </div>
            </l-control>



              <l-polygon ref="polygon_country" 
                v-for="(geom,index) in polygon.latlngs" :key="index" :lat-lngs="geom"
                :fillColor="colors(polygon.grid_code[index],index)"
                :weight="0"
                :fillOpacity="0.7"
                @click="polygondata(polygon.grid_code[index])"
                v-on:mouseover="polygondata(polygon.grid_code[index])"
              >
              <l-tooltip>{{polygon_grid_code}} mg/m<sup>2</sup></l-tooltip>
              </l-polygon>
             
              
         </l-map>
      
        </div>
        </div>
           
    </div>
   <div class="px-3">
     <div v-if="spinner" class="col-12 text-center rounded" style="background-color:gray">
       <div class="">
       <b-spinner class="" variant="primary" label="Text Centered"></b-spinner>      
       </div>
     </div>
    <div v-if="!spinner"  class="d-flex justify-content-around">
        <div class="d-flex">
            <b-icon  font-scale="1.8" style="color: #99A499;" class="align-self-center" icon="calendar2-week-fill" aria-hidden="true"></b-icon>
            <v-date-picker class="px-1 align-self-center" ref="slider" :masks="masks"
            v-model="valuecalendar"
            :from-date="valuecalendar"
            :attributes="attributes"
            :available-dates='AvailableDates'
            @dayclick="ApplyCalentar"
            >
            <template v-slot="{ inputValue,togglePopover }">
            <input
            class=" "
            @click.stop="dateSelected($event, inputValue, togglePopover)"
            :value="inputValue"  
            />
            </template>
            </v-date-picker>
            
        </div>
        <div class="d-flex align-items-center border border-dark p-2 rounded">  <b-icon icon="info-circle-fill" variant="success"></b-icon>&nbsp; Displayed hours are in UTC</div>
        <b-button-group>
          <b-button :disabled='PreviousEventButton' @click="PreviousEvent"><b-icon icon="caret-left-fill" aria-hidden="true"></b-icon>Previous Event</b-button>
          <b-button :disabled='NextEventButton' @click="NextEvent">Next Event <b-icon icon="caret-right-fill" aria-hidden="true"></b-icon></b-button>
          
         
        </b-button-group>
        <!--<div class="px-5">
            <b-form-checkbox size="sm"  button-variant="primary play-button" @change="play" v-model="checked1" name="check-button" button>
            <div class="">
            <b-icon v-if="!checked1" class="align-self-center" icon="play-circle-fill" aria-hidden="true"></b-icon>
            <b-icon v-if="checked1" class="align-self-center" icon="pause-circle-fill" aria-hidden="true"></b-icon>
            <p v-if="!checked1" class="px-2" style="margin-bottom: 0rem;">Play</p>
            <p v-if="checked1" class="px-2" style="margin-bottom: 0rem;">Stop</p>
            </div>
            </b-form-checkbox>
        </div>-->
    </div>

      <div class="d-flex">
        <div class="px-4">
            <b-form-checkbox size="sm"  button-variant="primary play-button" @change="play" v-model="checked1" name="check-button" button>
            <div class="">
            <b-icon v-if="!checked1" class="align-self-center" icon="play-circle-fill" aria-hidden="true"></b-icon>
            <b-icon v-if="checked1" class="align-self-center" icon="pause-circle-fill" aria-hidden="true"></b-icon>
            <p v-if="!checked1" class="px-2" style="margin-bottom: 0rem;">Play</p>
            <p v-if="checked1" class="px-2" style="margin-bottom: 0rem;">Stop</p>
            </div>
            </b-form-checkbox>
        </div>    
      <vue-slider class="mt-3" style="width:100%" v-model="value" :marks="marks"
       :data="data" :max="max"
        @change="changeDate"
        
       >
       </vue-slider>
     </div>
  </div>
  
</div>
</div>


</template>

<script>

import axios from 'axios'
import TopBar from './TopBar.vue'
import { LMap, LTileLayer, LMarker,LPolygon,LGeoJson, LCircle,LControl,LTooltip,LControlScale } from 'vue2-leaflet';
import VueSlider from 'vue-slider-component/dist-css/vue-slider-component.umd.min.js'
import 'vue-slider-component/dist-css/vue-slider-component.css'

import 'vue-slider-component/theme/default.css'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
//import Vue2LeafletHeatmap from './Vue2LeafletHeatmap.vue'
//import { Control } from 'leaflet';

var loopPLay;

export default {
    components:{
        LControlScale,
        LTooltip,
        LControl,
        LCircle,
        TopBar,
        LMap,
        LTileLayer,
        LMarker,
        VueSlider,
        LPolygon,
        LGeoJson,
        'v-date-picker':DatePicker,
        
       
    },

    data(){
        return{
        spinner:false,
        PreviousEventButton:false,
        NextEventButton:true,
        timeArray:null,
        start:0,
        end:7000,
        colorsArray:[],
        polygon_grid_code:'null',
        polygon: {
          latlngs: null,
          grid_code:null,
        },
        masks: {
            input: 'YYYY/MM/DD',
        },
          markers:[],
          radius: 4500,
        color: 'red',
        geojson:[],
        all_data:'',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        zoom: 7,
        center: [38.32, 23.80],
      valuecalendar:new Date(),
      checked1:false,
      attributes:null,
      max:1440,
      value: '0',
      data:null,
      marks:{},
      dates:null,
      AvailableDates:null,
      dateArray:[],
      
    }
    },
    async created(){
      
    //var Alldates= await axios.get("backend/dates-request.php")http://localhost/smoke_backend/
    //var Alldates= await axios.get("http://localhost/smoke_backend/dates-request.php")
    var Alldates= await axios.get("https://smoke.beyond-eocenter.eu/backend/dates-request.php")
    this.dates=Alldates.data
    //console.log(this.dates)
    //var all_object=await axios.get("http://localhost/smoke_backend/smoke_request.php",{params:{selectedDate:new Date()}})
   // this.all_data=all_object.data
    //console.log(this.all_data)
    
  var date=[]
  this.AvailableDates=[]
  this.AvailableDates.push(
      { start: new Date(),
        end: new Date()
      })
  for(var i=0; i<this.dates.length; i++){
    this.dateArray.push(this.dates[i].ddate)
    //console.log("Date1",this.dateArray)
    var newDate=new Date(this.dates[i].ddate)
    //console.log(newDate)
    date.push(newDate)
    this.attributes=[]
    this.attributes.push({
            bar: 'red',
            dates: date,
    })
    this.AvailableDates.push(
      { start: newDate,
        end: newDate
      })
  }
  
const today = new Date()
const tomorrow = new Date(today)
tomorrow.setDate(tomorrow.getDate() + 1)

//console.log(this.dateArray)
//console.log(tomorrow.toISOString().substr(0,10))
  if(this.dateArray.includes(tomorrow.toISOString().substr(0,10))){
   this.NextEventButton=false
  }
  
    this.slider()
    

  },
  methods: {
    async slider(){
      this.spinner=true
    //var all_object=await axios.get("backend/smoke_request.php",{params:{selectedDate:this.valuecalendar}})
    var all_object=await axios.get("https://smoke.beyond-eocenter.eu/backend/smoke_request.php",{params:{selectedDate:this.valuecalendar}})
    this.all_data=all_object.data
    if(!this.all_data){
      this.all_data=[]
    }
    this.timeArray=[]
    for(var i=0; i<this.all_data.length; i++){
        if(!this.timeArray.includes(this.all_data[i].dtime)){
          this.timeArray.push(this.all_data[i].dtime)
        }
    }
    //var hour=new Date(1200 * 1000).toISOString().substr(14,5)
    //console.log(hour)

    this.data={}
    for(var i=0; i<1440; i=i+15){
    var hour=new Date(i * 1000).toISOString().substr(14,5)
    this.data[i]= hour
    var second=new Date(i * 1000).toISOString().substr(17,2)
    second=parseInt(second)
    //console.log(hour2)
    //console.log(typeof(hour2))
    if(this.timeArray.includes(hour)){
    var backgroundcolor='#ca0000'
    var backgroundcolorText='rgba(255,0, 0, 0.1)'
    }else{
    var backgroundcolor='black'
    var backgroundcolorText='rgba(255, 0, 0, 0)'
    }
    if(second!==0){
      //console.log('here')

    this.marks[i]={
      style: {
              width: '4px',
              height: '4px',
              display: 'hide',
              backgroundColor: backgroundcolor,
            },
      labelStyle: {
              color: 'rgba(255, 0, 0, 0)'
            }}
    }else{

      this.marks[i]={
            label:hour,
            style: {
              width: '8px',
              height: '8px',
              backgroundColor: backgroundcolor,
              transform: 'translate(-2px, -2px)'
            },
            labelStyle: {
              color: backgroundcolor,
              backgroundColor: backgroundcolorText,
              borderRadius: '5px',
              padding: '3px',
            }
            }
    }
    }
    this.value='0'
    this.changeDataSmoke(this.value)
    this.spinner=false
    },
    async ApplyCalentar(){
    
      this.slider()
      var calendarValue=new Date(this.valuecalendar).toISOString().substr(0,10)
      var index=this.dateArray.indexOf(calendarValue)
      if(index===0){
        this.PreviousEventButton=false
        this.NextEventButton=true
      }
      else if(index===(this.dateArray.length-1)){
        this.PreviousEventButton=true
        this.NextEventButton=false
      }
      else{
        this.PreviousEventButton=false
        this.NextEventButton=false
      }

      var today=new Date().toISOString().substr(0,10)
      if(!this.dateArray.includes(today) && calendarValue===today){
      
        this.PreviousEventButton=false
        this.NextEventButton=true
       
      }

    },

    play(){
    //console.log(this.checked1)
    
    if(this.checked1){
     // console.log(this.value)
      loopPLay= setInterval(function(){ 
      var num=parseInt(this.value)+15
       if(num>1425){
        //this.value='0'
        this.checked1=false
        clearInterval(loopPLay);
        
      }else{
      this.value= num.toString()
      this.changeDataSmoke(num)
      }
     }.bind(this), 500);

      
    }else{
      clearInterval(loopPLay);
    }
    },
    changeDate(){
    //console.log(this.value)
  
    this.changeDataSmoke(this.value)
  
    },
    changeDataSmoke(value){
    var time=new Date(value * 1000).toISOString().substr(14,5)
    //console.log(time)
    var j=0;
    this.polygon.latlngs=[]
    this.polygon.grid_code=[]
    if(this.timeArray.includes(time)){ 
      
    for(var i=0; i<this.all_data.length; i++) {
      
      // console.log(geojson_pgons)
      if(this.all_data[i].dtime===time){
      const latlgn = L.geoJSON(JSON.parse(this.all_data[i].smoke_geom))
      const latlgn_id = latlgn._leaflet_id - 1
      // console.log(latlgn)
      const latlgn_data = latlgn._layers[latlgn_id]._latlngs

      this.polygon.latlngs[j] = latlgn_data
      this.polygon.grid_code[j]=this.all_data[i].grid_code
      j++;

      }

    }
    }
    

   //this.polygon.grid_code.sort(); 
   //console.log(this.polygon.latlngs)
   //console.log(this.polygon.grid_code)

    },
    dateSelected(e, date, toggle) {
      //this.selected = date;
      toggle({ ref: e.target });
    },
    polygondata(data){
      //console.log(data)
      this.polygon_grid_code=Math.floor(data)
    },
    PreviousEvent(){
     // this.valuecalendar=
     //console.log(new Date(this.valuecalendar).toISOString().substr(0,10))
    var today=new Date().toISOString().substr(0,10)
    var calendarValue=new Date(this.valuecalendar).toISOString().substr(0,10)
    //this.valuecalendar='2020-09-04'
      
     console.log("Date Array",this.dateArray)
     // console.log(today)
     if(!this.dateArray.includes(today) && calendarValue===today){
      
       this.valuecalendar=this.dateArray[0]
       
     }else{
       this.NextEventButton=false
       var index=this.dateArray.indexOf(calendarValue)
       //console.log(index)
       this.valuecalendar=this.dateArray[index+1]
       //console.log(this.dateArray.length)
       if(this.dateArray.length===(index+2)){
         this.PreviousEventButton=true
       }
     }
    this.polygon.latlngs=[]
    this.value='0'
    this.slider()
     //new Date(this.dates[i].ddate)
     //console.log(this.dateArray)
    },
    NextEvent(){
     // var today=new Date().toISOString().substr(0,10)
      var calendarValue=new Date(this.valuecalendar).toISOString().substr(0,10)
   
      this.PreviousEventButton=false
      var index=this.dateArray.indexOf(calendarValue)
       //console.log(index)
      this.valuecalendar=this.dateArray[index-1]
       //console.log(this.dateArray.length)
      if(index===1){
         this.NextEventButton=true
      }
      this.polygon.latlngs=[]
      this.value='0'
      this.slider()
    },
    colors(data,i){
      //  console.log(i)
      if(data<this.start){
        return 'rgb(0,0,255)'
         //'#36cc00'
      }
      if(data>=this.start && data<=this.end){
        var num=(this.end-this.start)/298;

        var test =Math.floor((data-this.start) / num);
        //console.log(test)
        
        return this.colorsArray[test]
      }
      else{
        return 'rgb(137,0,0)'
      }
     
    }
   
  },
  mounted(){
   
    var r=0
    var g=0
    var b=255
    for(var i=0; i<=298; i++){
      if(r<70 && g<145 && b===255){
        this.colorsArray.push('rgb('+r+','+g+','+b+')')
        r=r+2
        g=g+5
        
      }
      if(r<168 && g>=145 && b===255){
        this.colorsArray.push('rgb('+r+','+g+','+b+')')
        r=r+2
        g=g+2
        
      }
      if(r>=168 && g===255 && b>0){
        this.colorsArray.push('rgb('+r+','+g+','+b+')')
        r=r+3
        b=b-8
        if(r===255){
          b=0
        }  
      }
      if(r===255 && g>0 && b===0){
        this.colorsArray.push('rgb('+r+','+g+','+b+')')
        g=g-2
        
      }
      if(r>137 && g===1 && b===0){
        this.colorsArray.push('rgb('+r+','+g+','+b+')')
        r=r-2
        
      }

    }
   
  },
    

}
</script>

<style>
.panel-heading {
    padding: 10px 15px;
    border-bottom: 1px solid transparent;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    color: #fff;
    font-family: Trebuchet MS,Helvetica,sans-serif;
    font-style: italic;
}

 .active {
    background: #b80101 !important;
    color: #ffffff !important;
  }

.loader{
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 1001;
  background: url('../../public/img/load1.gif') 50% 50% no-repeat rgba(255,193,249,0.5)

}

.col{
    padding-right: 0px; 
    padding-left: 0px;
}
.card{
    margin-bottom: 0px;
    height:100%;
    border-radius: .0rem;
}
.chard-checkbox{
     background-color: rgba(135, 144, 152,0.8)!important;
}
.ol-zoom {
     left: unset;
     right: 8px;
}
.vc-popover-content-wrapper[data-v-05016e86]{
    z-index: 1001!important;
}
.box{
  width: 2px; height: 20px;
}
p{
  margin-bottom: 0rem;
}
.text{
  font-size:12px;
  color: #fff;
}
.vl {
  border-left: 4px solid rgb(255, 255, 255);
  height: 5px;
}
.leaflet-container {
    font: 20px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif !important;
}

.play-button {
    background:green;
    border-color: #99A499;
}

.play-button:hover {
    background:green;
    border-color: #99A499;
}

.play-button:active {
    background:green;
    border-color: #99A499;
}

.play-button:focus,
.play-button.focus {
    background:green;
    border-color: #99A499;
}

.leaflet-control-scale-line {
    background: #FFF!important;
}

</style>
